<template>
  <el-select v-model="inputKW" filterable placeholder="请输入小程序名称">
    <el-option
      v-for="item in applist"
      :key="item.id"
      :label="item.placement?item.name+'--'+item.placement:item.name"
      :value="item.id"
      @click.native="change(item)"
      default-first-option
    ></el-option>
  </el-select>
</template>
<script>
const props = {
  compare: { type: String, default: "name" },
  pholder: { type: String, default: "" },
  sstyle: { type: String, default: "width:200px" }
};
export default {
  props,
  data() {
    return {
      applist: [],
      compares: this.compare,
      inputKW: this.pholder,

      ptext:'请输入小程序名称',
    };
  },
  watch: {
    pholder(val) {
      this.inputKW = val;
    }
  },
  mounted() {
    this.getData();
    if(this.compares=='version'){
        this.ptext='请输入版本号'
    }else{
        this.ptext='请输入小程序名称'
    }
  },
  methods: {
    getData() {
      if (this.compares == "name") {
        this.applist = this.$store.applist;
      } else if (this.compares == "version") {
        this.applist = this.$store.vlist;
      } else if (this.compares == "pid") {
        this.applist = this.$store.plist;
        // console.log(this.applist);
        // this.compares = "name";
      }
      if(!this.applist){
          setTimeout(() => {
              this.getData();
          }, 300);
      }
    },
    change(s) {
      this.$emit("getid", s.id);
      this.$emit("getInfo", s);
    }
  }
};
</script>



// WEBPACK FOOTER //
// searchApp.vue?215ec030